import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  HttpLink,
} from "@apollo/client"
import { RetryLink } from "@apollo/client/link/retry"
import { onError } from "@apollo/client/link/error"

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_API_ENDPOINT,
  credentials: "include", // Include cookies for authentication.
})

// Retry once on all errors except auth errors.
const retryLink = new RetryLink({
  attempts: {
    max: 3,
    retryIf: (error, _operation) => {
      if (error && error.statusCode === 401) {
        return false
      }
      return !!error
    },
  },
})

// Redirect users to the login portal if we receive a 401 unauthorized.
export const authRedirectLink = onError(({ graphQLErrors, networkError }) => {
  if (networkError) {
    switch (networkError.statusCode) {
      case 401: {
        window.location =
          process.env.REACT_APP_AUTH_DOMAIN +
          "/users/sign_in?return_to=" +
          encodeURIComponent(window.location)
        break
      }
      case 403: {
        window.location = "https://www.swipesense.com/"
        break
      }
      default:
      // don't redirect if the error code is something other than the ones explicitly specified above
    }
  }
})

const client = new ApolloClient({
  name: "contact_tracing",
  cache: new InMemoryCache(),
  link: ApolloLink.from([authRedirectLink, retryLink, httpLink]),
  defaultOptions: {
    // Apollo caches all objects returned from the server. If a new query updates an existing object, other components
    // utilizing that object will refetch their query to ensure they have the latest view of all that object's fields.
    // When using a mock server, fields often have semi-random responses which can cause cascading updates throughout
    // the component tree. We don't want this while developing locally, so disable the behavior via fetchPolicy.
    watchQuery: {
      fetchPolicy:
        process.env.NODE_ENV === "development" ? "no-cache" : "cache-first",
    },
  },
})

export default client
